module.exports = __webpack_public_path__ + "ubisoft_plus_slide_mobile.webp";